import { Page, Section, useApiQuery } from "../app/Page";
import { useCan } from "../app/session";
import { useT } from "../i18n";
import { Empty } from "../ui/states";
import { Table } from "../ui/Table";
import { ApiKeys } from "./ApiKeys";
import { Credentials } from "./Credentials";

export function DevelopersPage() {
  const t = useT();
  const keys = useApiQuery("api-keys", (api) => api.GET("/v1/api-keys", { params: { query: { limit: 100 } } }));
  const canCredentials = useCan("credentials:write");
  const credentials = useApiQuery("credentials", (api) => api.GET("/v1/credentials", { params: { query: { limit: 200 } } }), {
    enabled: canCredentials,
  });
  const hooks = useApiQuery("webhook-endpoints", (api) =>
    api.GET("/v1/webhook-endpoints", { params: { query: { limit: 100 } } }),
  );
  return (
    <Page title={t("nav.developers")} description={t("developers.description")}>
      {canCredentials && (
        <div id="credentials" className="scroll-mt-4">
          <Section title={t("credentials.title")} query={credentials}>
            {(page) => <Credentials credentials={page.data} />}
          </Section>
        </div>
      )}
      <Section title={t("developers.keys")} query={keys}>
        {(page) => <ApiKeys keys={page.data} />}
      </Section>
      <Section title={t("developers.webhooks")} query={hooks}>
        {(page) =>
          page.data.length === 0 ? (
            <Empty title={t("developers.webhooksEmpty")}>
              <p>{t("developers.webhooksEmptyBody")}</p>
            </Empty>
          ) : (
            <Table
              caption={t("developers.webhooks")}
              rows={page.data}
              rowKey={(e) => e.id}
              columns={[
                { header: t("developers.col.url"), cell: (e) => <span className="font-mono">{e.url}</span> },
                {
                  header: t("developers.col.events"),
                  cell: (e) => (e.event_types.length ? e.event_types.join(", ") : t("developers.allEvents")),
                },
                { header: t("developers.col.enabled"), cell: (e) => t(e.enabled ? "common.yes" : "common.no") },
              ]}
            />
          )
        }
      </Section>
    </Page>
  );
}
